import { I18NState } from '@common/store/i18n/models/i18n.models';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectI18NState = createFeatureSelector<I18NState>('i18n');
export const selectI18N = createSelector(selectI18NState, state => {
    return state.i18n;
});

export const selectTranslatedKey = (key: string, def?: string) =>
    createSelector(selectI18N, i18n => {
        if (key) {
            if (key.indexOf('=') > -1) {
                def = key.substr(key.indexOf('=') + 1, key.length);
                key = key.substr(0, key.indexOf('='));
            }

            if (!def) def = key;

            if (i18n[key]) {
                return i18n[key];
            }
            return def;
        }
    });
